/**
 * @generated SignedSource<<0c0fb07309688b3e038d53d5f76cd0f4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShopifyAppEmbedStatus = "DISABLED" | "ENABLED" | "NOT_APPLICABLE";
export type shopifyAppEmbedBannerStatusQuery$variables = {
  salesChannelID: string;
};
export type shopifyAppEmbedBannerStatusQuery$data = {
  readonly shopifyAppEmbedStatus: ShopifyAppEmbedStatus;
};
export type shopifyAppEmbedBannerStatusQuery = {
  response: shopifyAppEmbedBannerStatusQuery$data;
  variables: shopifyAppEmbedBannerStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "kind": "ScalarField",
    "name": "shopifyAppEmbedStatus",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "shopifyAppEmbedBannerStatusQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "shopifyAppEmbedBannerStatusQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "0913646cdf8799739234dea8a42dd4ae",
    "id": null,
    "metadata": {},
    "name": "shopifyAppEmbedBannerStatusQuery",
    "operationKind": "query",
    "text": "query shopifyAppEmbedBannerStatusQuery(\n  $salesChannelID: ID!\n) {\n  shopifyAppEmbedStatus(salesChannelID: $salesChannelID)\n}\n"
  }
};
})();

(node as any).hash = "ab3614183b0833545bf509967692a4bd";

export default node;
